import trimEnd from 'lodash/trimEnd';
import trimStart from 'lodash/trimStart';

export const buildPublicUrl = (path: string): string =>
    trimEnd(process.env.PUBLIC_URL || '/', '/') + '/' + trimStart(path, '/');

export const buildRelativeUrl = (path: string) =>
    trimEnd(process.env.REACT_APP_BASE_PATHNAME || '/', '/') + '/' + trimStart(path, '/');
